import { createContext } from 'react';

export const LicensingContext = createContext({ isLicenseNeeded: true, status: null });
